import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Pageable } from '../interfaces/pageable.interface';
import { Tariff, TariffView } from '../interfaces/tariff.interface';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class TariffService {
  constructor(
    private http: HttpClient,
    private env: EnvironmentService) {
  }

  getHsCodes(tariffCode?: any, size?:any, page?:any): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    const params = new HttpParams()
      .set('size', tariffCode && tariffCode.trim() ? 1000 : size || 1000)
      .set('page', tariffCode && tariffCode.trim() ? 0 : page || 0);

    return this.http.get<any>(envValue.baseUrl + '/rdm' + envValue.wso2amApiVersion + '/api/v1/getTariffCode', { params }).pipe(
      map((response: any) => {
        let filteredContent = response?.content || [];

        if (tariffCode && tariffCode.trim()) {
          filteredContent = filteredContent.filter((item: any) =>
            item && item.toLowerCase().includes(tariffCode.toLowerCase())
          );
        }

        return {
          tariffSearchDto: {
            content: filteredContent.map((code: string, index: number) => ({ 
              tariffId: index + 1,
              tariffCode: code, 
              description: code,
              shortDescriptionInEnglish: code,
              shortDescriptionIn: code
            })),
            totalElements: filteredContent.length,
            numberOfElements: filteredContent.length,
            totalPages: Math.ceil(filteredContent.length / (size || 10)),
            number: page || 0,
            first: (page || 0) === 0,
            last: (page || 0) >= Math.ceil(filteredContent.length / (size || 10)) - 1,
            pageable: {
              pageNumber: (page || 0) + 1,
              offset: ((page || 0) * (size || 10))
            }
          }
        };
      })
    );
  }

  getCommodityHSCode(hsCode: any, searchQuery: any, destinationCountryIso: string, size?: any, page?: any, chapter?: any): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    let params = new HttpParams()
      .set('hsCode', hsCode || '')
      .set('description', searchQuery || '')
      .set('destinationCountryIso', destinationCountryIso)
      .set('size', size ? size : 1000)
      .set('page', page ? page : 0);
    if (chapter) {
      params = params.set('chapterCode', chapter);
    }
    return this.http.get<Pageable<Tariff>>(envValue.baseUrl+ "/rdm" +envValue.wso2amEndPoint+ envValue.wso2amApiVersion + "/api/v1/tariff/searchByHsCodeAndDescription", {params: params}).pipe(
      map((response: any) => {
        let filteredContent = response?.content?.content || [];
        return {
          tariffSearchDto: {
            content: filteredContent,
            totalElements: response.content?.totalElements,   // ✅ FIX
            numberOfElements: filteredContent.length,        // ✅ FIX
            totalPages: response.content?.totalPages,
            number: response.content?.number,
            first: response.content?.first,
            last: response.content?.last,
            pageable: {
              pageNumber: (page || 0) + 1,
              offset: ((page || 0) * (size || 10))
            }
          }
        };
      })
    );
  }
  getCustomInfoHsCodes(hsCode: any,searchQuery:any, destinationCountryIso: string, size?:any, page?:any): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams()
      .set('hsCode', hsCode)
      .set('description',searchQuery)
      .set('destinationCountryIso', destinationCountryIso)
      .set('size', size)
      .set('page', page)
    return this.http.get<Pageable<Tariff>>(envValue.wso2amEndPoint+ "/unifiedsource" + envValue.wso2amApiVersion + "/api/v1/tariff/search", {params: params});
  }

  getLpcoHsCodes(docType?: any): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams().set('documentType', docType);
    return this.http.get<Pageable<Tariff>>(envValue.wso2amEndPoint+ "/tariff" + envValue.wso2amApiVersion + "/api/v1/tariffControlDetailsSearch", {params: params});
  }

  loadLpcoHsCodes(docType?: any,ministry?:any,department?:any,tariffCode?:any): Observable<any> {
    const envValue:any = this.env.getEnvironment();
    return this.http.post<Pageable<Tariff>>(envValue.wso2amEndPoint+ "/tariff" + envValue.wso2amApiVersion + "/api/v1/tariffControl/searchLpcoHsCode", {"ministry": ministry, "department": department, "docType": docType, "tariffCode": tariffCode });
  }

  getHsCodesByDescription(searchValue?: any,shortDescriptionInEnglish?: any, size?: number, page?: number): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    const params = new HttpParams()
      .set('hsCode', searchValue || '')
      .set('description', shortDescriptionInEnglish || '')
      .set('size', size || 10)
      .set('page', page || 0);

    return this.http.get<any>(envValue.baseUrl + '/rdm' + envValue.wso2amApiVersion + '/api/v1/tariff/searchByHsCodeAndDescription', { params }).pipe(
      map((response: any) => {
        return {
          tariffSearchDto: response?.content || response
        };
      })
    );
  }

  getTariffMaster(id: number): Observable<TariffView> {
    const envValue:any = this.env.getEnvironment();
    return this.http.get<TariffView>(envValue.wso2amEndPoint+ "/tariff" + envValue.wso2amApiVersion + "/api/v1/getTariffMaster/" + id);
  }

  getFTADetailsbyTariffCode(hsCode: string, destinationCountryIso: string): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    const params = new HttpParams().set('destinationCountryIso', destinationCountryIso);
    return this.http.get<any>(envValue.wso2amEndPoint + "/unifiedsource" + envValue.wso2amApiVersion + "/api/v1/tariff/" + hsCode + "/notes", { params });
  }

  getTariffDetails(tariffCode:string,destination:string){
    const envValue:any = this.env.getEnvironment();
    const params = new HttpParams().set('destination', destination);
    return this.http.get<TariffView>(envValue.wso2amEndPoint+ "/unifiedsource" + envValue.wso2amApiVersion + "/api/v1/tariff/"+tariffCode , {params: params});
  }

  getHsCodesByMappingId(mappingId: string, page: number, size: number, searchText?:string): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    let params = new HttpParams().set('page', page).set('size', size).set('sort', 'hsCode,asc');
    if (searchText) {
      params = params.set('hsCodes', searchText); // set hsCodes as a separate query param
    }
    return this.http.get(`${envValue.baseUrl}/rdm/api/v1/hs-code-mapping/${mappingId}/hs-codes`, {params})
  }

  searchByHsCodeDescriptionAndHsType(hsCode?: string | null, description?: string | null, hsType?: string | null, size?: number, page?: number, isMapping?: boolean): Observable<any> {
    const envValue: any = this.env.getEnvironment();
    let params = new HttpParams()
      .set('hsCode', hsCode || '')
      .set('description', description || '')
      .set('hsType', hsType || '')
      .set('size', size || 10)
      .set('page', page || 0);
    if (isMapping) {
      params = params.set('isMapping', 'true');
    }
    return this.http.get<any>(envValue.baseUrl + '/rdm/api/v1/tariff/searchByHsCodeDescriptionAndHsType', { params }).pipe(
      map((response: any) => {
        return {
          tariffSearchDto: response?.content || response
        };
      })
    );
  }
}
 